import { useState } from 'react';
import { api } from '@/services/api';

/**
 * Hook for handling form submission
 *
 * @param {string} formGuid - The form GUID from the URL routing parameter
 */
export const useFormSubmit = (formGuid) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const submit = async (data) => {
    if (!formGuid) {
      setError('Form GUID is required for submission');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      setSuccess(false);

      const response = await api.submitForm(formGuid, data);

      if (response.success) {
        setSuccess(true);
      } else {
        setError(response.error || 'Unknown error');
      }
    } catch (err) {
      setError('Failed to submit form');
    } finally {
      setLoading(false);
    }
  };

  return { submit, loading, error, success };
};
